import React from 'react';
import { InputList, InputWrapperProps } from 'framework/form';
import { Box } from '@mui/material';

const IdentityDocumentListInput = ({ inputTemplate, ...props }: InputWrapperProps) => {
  return (
    <Box sx={{ width: '100%' }}>
      <InputList {...props} maxFields={10} minFields={1} inputTemplate={inputTemplate} rowSx={{ width: '100%' }} />
    </Box>
  );
};

export default IdentityDocumentListInput;
